<template>
    <div class="flex items-center gap-x-5 cursor-pointer text-bzMenuText hover:text-white text-xs font-bold uppercase rounded-sm">
        <slot />
    </div>
</template>